import React from "react";
import { VacantUnit } from "./vacant";
import { withTranslation } from 'react-i18next';

class VacantParent extends React.Component {
    constructor(props) {
    super(props);
    this.state = {

    }
  }
  render() {
    return <VacantUnit  {...this?.props}/>;
  }
}

export default withTranslation('vacantunit') (VacantParent);